import API from './API';

export default class Contato extends API {

  static lista() {
    return super.get(`/contatos`);
  }

  static cadastro(dados){
    return super.post(`/ws/newsletter`, dados);
  }

  static mensagem(dados){
    return super.post(`/ws/mensagem`, dados);
  }

}



// WEBPACK FOOTER //
// ./src/services/api/Contato.js